import { render, staticRenderFns } from "./AsiaVhisPolicyActions.vue?vue&type=template&id=55589c3c"
import script from "./AsiaVhisPolicyActions.vue?vue&type=script&lang=js"
export * from "./AsiaVhisPolicyActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports